module.exports = __webpack_public_path__ + "h5/img/2_02.88365f51.png";